/** Reclamo sobre una compra (`/returns/admin`). El backend resuelve estado, responsable y acciones. */
export interface ClaimFile {
  url: string;
  name?: string | null;
  type?: string | null;
  by?: string;
}

export interface ClaimEvent {
  id: number;
  eventType: string;
  fromStatus?: string | null;
  toStatus?: string | null;
  actorRole: string;
  actorName?: string | null;
  note?: string | null;
  metadata?: Record<string, unknown> | null;
  notifiedBuyer?: boolean;
  notifiedSeller?: boolean;
  createdAt: string;
}

export interface Claim {
  id: number;
  paymentId: number;
  ticketId?: number | null;
  status: string;
  statusLabel: string;
  nextActor: 'buyer' | 'seller' | 'admin' | 'none';
  nextActorLabel: string;
  nextStep: string;
  reasonCode?: string | null;
  reason?: string | null;
  description?: string | null;
  evidence: ClaimFile[];
  returnShipping: {
    required: boolean | null;
    payer?: string | null;
    labelGeneratedBy?: string | null;
    carrier?: string | null;
    labelStatus?: string | null;
    labelUrl?: string | null;
    trackingNumber?: string | null;
    incident?: string | null;
  };
  review: {
    receivedAt?: string | null;
    dueAt?: string | null;
    deadlineState: 'none' | 'on_time' | 'due_soon' | 'overdue';
    overdueAt?: string | null;
    result?: string | null;
    notes?: string | null;
  };
  resolution: {
    decision?: string | null;
    decisionLabel?: string | null;
    notes?: string | null;
    refundAmountCents?: number | null;
    refundStatus?: string | null;
    refundBearer?: string | null;
    refundError?: string | null;
  };
  closeNotes?: string | null;
  actions: string[];
  events?: ClaimEvent[];
  payment?: { id: number; amountCents: number; refundedCents: number; partName?: string | null; status?: string } | null;
  parties?: Record<string, string | null>;
  buyerName?: string | null;
  buyerEmail?: string | null;
  sellerName?: string | null;
  assignedAdminId?: number | null;
  createdAt: string;
  updatedAt: string;
}

export const CLAIM_ACTOR_LABELS: Record<string, string> = {
  buyer: 'Comprador',
  seller: 'Vendedor',
  admin: 'Soporte',
  none: '—',
};

export const CLAIM_DECISIONS = [
  { value: 'refund_full', label: 'Reembolso total' },
  { value: 'refund_partial', label: 'Reembolso parcial' },
  { value: 'replacement', label: 'Reposición de la pieza' },
  { value: 'rejected', label: 'No procede' },
  { value: 'no_action', label: 'Resuelto sin movimiento de dinero' },
] as const;

export const CLAIM_EVENT_LABELS: Record<string, string> = {
  created: 'Reclamo abierto',
  review_started: 'Soporte tomó el caso',
  assigned: 'Caso asignado',
  info_requested: 'Se pidió información',
  info_provided: 'Información recibida',
  return_approved: 'Devolución aprobada',
  label_generated: 'Guía generada',
  label_incident: 'Incidencia con la guía',
  shipped: 'Pieza enviada de regreso',
  carrier_pickup: 'Recolección de la paquetería',
  received: 'Pieza recibida',
  inspection: 'Revisión registrada',
  review_reminder: 'Recordatorio de plazo',
  review_overdue: 'Plazo vencido (escalado)',
  decision: 'Resolución',
  refund_succeeded: 'Reembolso procesado',
  refund_failed: 'Reembolso fallido',
  comment: 'Comentario',
  internal_note: 'Nota interna',
  closed: 'Cerrado',
  cancelled: 'Retirado por el comprador',
};
